import { createApp } from 'vue'
import ElementPlus from "element-plus"
import "element-plus/dist/index.css"
import 'vant/lib/index.css';
import './assets/css/global.styl'
import App from './App.vue'
import { createPinia } from "pinia";
import Clipboard from 'v-clipboard'
import { download } from "@/utils/http";
import "katex/dist/katex.min.css"

import '@/assets/iconfont/chatReply/iconfont.css';
import '@/assets/iconfont/common/iconfont.css';
import '@/assets/iconfont/industry-standard/iconfont.css';
import '@/assets/iconfont/job-knowledge/iconfont.css';
import '@/assets/iconfont/laboratory/iconfont.css';
import '@/assets/iconfont/law/iconfont.css';
import '@/assets/iconfont/pay/iconfont.css';
import '@/assets/iconfont/personal-center/iconfont.css';
import '@/assets/iconfont/resource/iconfont.css';
import '@/assets/iconfont/steel-structure/iconfont.css';
import '@/assets/iconfont/technology/iconfont.css';


import {
    Button,
    Cell,
    CellGroup,
    ConfigProvider,
    Dialog,
    DropdownItem,
    DropdownMenu,
    Field,
    Form,
    Icon,
    Image,
    List,
    NavBar,
    Notify,
    Picker,
    Popup,
    Search,
    ShareSheet,
    Sticky,
    SwipeCell,
    Switch,
    Tabbar,
    TabbarItem,
    Tag,
    TextEllipsis,
    Uploader
} from "vant";
import router from "@/router";

const app = createApp(App)
app.config.globalProperties.download = download;

app.use(createPinia())
app.use(ConfigProvider);
app.use(Clipboard);
app.use(Tabbar);
app.use(TabbarItem);
app.use(NavBar);
app.use(Search);
app.use(Cell)
app.use(Image)
app.use(TextEllipsis)
app.use(Notify)
app.use(Picker)
app.use(Popup)
app.use(List);
app.use(Form);
app.use(Field);
app.use(CellGroup);
app.use(Button);
app.use(DropdownMenu);
app.use(Icon);
app.use(DropdownItem);
app.use(Sticky);
app.use(SwipeCell);
app.use(Dialog);
app.use(ShareSheet);
app.use(Switch);
app.use(Uploader);
app.use(Tag);
app.use(router).use(ElementPlus).mount('#app')

// const md = require('markdown-it')({ breaks: true });
// 使用markdown-it-katex插件来支持KaTeX渲染
// md.use(require('markdown-it-katex'));
// 输入包含数学公式的Markdown文本
// const mathText = `![trump.png](https://img-blog.csdnimg.cn/04861952acba43858cfebb144ccb5243.png#width-full)`

// 渲染包含数学公式的Markdown文本
// const renderedText = md.render(mathText);

// 打印渲染后的内容
// console.log(renderedText);